import { ChevronDown } from 'lucide-react';
import type { SelectHTMLAttributes } from 'react';

/** A native select with the house chevron, inset from the right edge. */
export function Select({ className = '', children, ...rest }: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <div className="relative mt-1">
      <select
        {...rest}
        className={`w-full appearance-none rounded-lg border border-line bg-surface py-2 pl-3 pr-10 text-sm text-ink outline-none focus:border-sage disabled:opacity-50 ${className}`}
      >
        {children}
      </select>
      <ChevronDown
        size={16}
        aria-hidden
        className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-ink-faint"
      />
    </div>
  );
}
